import { useUserStore } from '@/stores/user'
import { useAccessStore } from '@/stores/access'
import { canWith, type AccessRow, type Action } from '@/utils/accessDomains'

export interface CanOptions {
  projectId?: number | string | null
  row?: AccessRow
  orgId?: number | string | null
  allowSuperUser?: boolean
}

export function can(obj: string, act: Action, { orgId, allowSuperUser, ...options }: CanOptions = {}): boolean {
  const view = orgId == null ? useAccessStore().view : useAccessStore().viewFor(orgId)
  if (allowSuperUser && view?.is_super_user) return true
  return canWith(view, useUserStore().member?.member_id, obj, act, options)
}

export function isOwnerOrSuperUser(orgId?: number | string | null): boolean {
  const view = orgId == null ? useAccessStore().view : useAccessStore().viewFor(orgId)
  return !!(view?.is_owner || view?.is_super_user)
}

export function useCan() {
  return can
}

type FeatureProps = AccessRow & { project_id?: number | null }

export function canFeature(act: Action, properties?: FeatureProps | null): boolean {
  if (!properties?.project_id) return false
  return can('project_feature', act, { projectId: properties.project_id, row: properties, allowSuperUser: true })
}

export function canFeatureResource(act: Action, properties?: FeatureProps | null): boolean {
  return canFeature('update', properties)
    && can('feature_resource', act, { projectId: properties!.project_id, allowSuperUser: true })
}
